import {
  fetchKidsBookDetailAPI,
  fetchKidsSeriesAPI,
  fetchSearchKidsBookAPI,
} from '@/apis/repositories/controllers/kidsRepository';
import { KidsBookSearchPayload, KidsCategory } from '@/apis/repositories/types/kids';

export function fetchKidsSeries(category?: KidsCategory) {
  return fetchKidsSeriesAPI(category);
}

export function fetchSearchKidsBook(params: KidsBookSearchPayload) {
  return fetchSearchKidsBookAPI(params);
}

export function fetchKidsBookDetail(bookSeq: number, withAttachment?: boolean) {
  return fetchKidsBookDetailAPI(bookSeq, withAttachment);
}
